export const LOG_ACTIONS = `
query logActions(
  $tenant_id: Int!,
  $skip: Int,
  $take: Int,
  $orderBy: LogActionOrderInput,
  $filter: FilterLogActionInput
){
	logActions(
    tenant_id:$tenant_id,
    skip:$skip,
    take:$take,
    orderBy:$orderBy,
    filter:$filter    
  ){
    __typename
    ...on LogAction{
      id,
      name,
      translation_key
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;
